module.exports = __webpack_public_path__ + "static/media/coins.a58fa81f.svg";